import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { GridContainer, GridItem } from "@insite/mobius/index";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface NewsPageViewStyles {
    authorText?: TypographyProps;
    publishDateText?: TypographyProps;
    newsWrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    dateAndAuthorWrapper?: InjectableCss;
    leftSideColumn?: GridItemProps;
    rightSideColumn?: GridItemProps;
    container?: GridContainerProps;
}

export const newsPageViewStyles: NewsPageViewStyles = {
    container: {
        gap: 10,
        css: css`
            width: 100%;
            padding: 0 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: flex;
                            flex-direction: column;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    newsWrapper: {
        css: css`
            .section-content-wrapper {
                padding-right: 30px;
                margin-top: 15px;
                margin-bottom: 15px;
            }
            .blog-sub-section-one {
                display: inline-block;
                /*width: 63%;*/
                width: 100%;
                padding-right: 30px;
            }
            .list_bullets {
                margin-bottom: 15px;
            }
            .list_bullets ul li,
            .list_bullets ol li {
                position: relative;
                padding: 10px;
                line-height: 20px;
                padding-top: 0;
                vertical-align: top;
                font-size: 15px;
                list-style: none;
            }
            .list_bullets ul li ul {
                margin-top: 1em;
            }
            .listing-content ul li:after,
            .list_bullets ul li:after {
                content: "";
                height: 5px;
                width: 5px;
                background-color: #931a1d;
                border-radius: 50%;
                display: inline-block;
                position: absolute;
                top: 6px;
                left: 0;
            }
            .list_bullets ol li {
                list-style: decimal;
            }
            .list_bullets ol li p {
                margin-bottom: 0;
            }
            ul,
            ol {
                margin-left: 2.5em;
            }
            ul,
            li {
                list-style: none outside none;
                margin: 0;
            }
            a:hover,
            a:focus {
                > ${TypographyStyle} {
                    text-decoration: underline;
                }
            }
            .btn-group {
                margin-bottom: 15px;
                text-align: center;
            }
            .btn-cta {
                text-transform: uppercase;
                line-height: normal;
            }
            .clear {
                clear: both;
            }
            .para_align {
                float: left;
                width: 66%;
            }
            .left_contentalign,
            .right_contentalign {
                float: left;
            }
            .video_block {
                margin-bottom: 15px;
            }

            .btn.primary {
                background-size: 100% 200%;
                background-color: ${getColor("primary")};
                transition: all 200ms ease-in-out;
                padding: 12px;
                span {
                    font-size: 15px;
                    font-weight: bold;
                }
                > ${TypographyStyle} {
                    color: ${getColor("secondary.contrast")} !important;
                    font-family: "GibsonRegular";
                }
                &:hover {
                    background-color: hsl(354.6, 73.7%, 33.4%);
                    > ${TypographyStyle} {
                        text-decoration: none;
                    }
                }
            }

            /* p:first-child:has(span) {
                text-align: center;
            } */

            ${LazyImageStyle} {
                max-width: 100% !important;
                > img {
                    height: inherit;
                }
            }

            h2 {
                text-transform: uppercase !important;
            }

            hr {
                border: solid #ddd;
                border-width: 1px 0 0;
                clear: both;
                margin: 1.25rem 0 1.1875rem;
                height: 0;
            }

            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
                .grayWrapper .acq_box a.btn.primary.btn-cta {
                    padding: 0.5em;
                    font-size: 13px;
                }
            }

            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: portrait) {
                .img_align {
                    float: none !important;
                }
            }

            @media (max-width: 640px) {
                .blog-sub-section-one {
                    width: 100%;
                    padding-right: 0;
                }
            }

            @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (orientation: portrait) {
                .para_align {
                    width: 57%;
                }
            }

            @media only screen and (max-width: 767px) {
                .section-content-wrapper {
                    padding-right: 0;
                }
                .section-content-wrapper .left_contentalign br {
                    display: none;
                }
                .btn-group.btn_mobile a.btn.primary.btn-cta {
                    width: 100%;
                    margin-bottom: 1em;
                }
                .btn-group.btn_mobile a.btn.primary.btn-cta {
                    width: 100%;
                    margin-bottom: 1em;
                }
                .img_align {
                    float: none !important;
                }
                .para_align {
                    width: 100%;
                    float: none;
                }
                .left_contentalign {
                    width: 100%;
                    float: none;
                }
                .section-content-wrapper .left_contentalign br {
                    display: none;
                }
                .video_block iframe {
                    width: 100%;
                    height: 100%;
                }
            }

            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
                .para_align {
                    width: 54%;
                }
            }

            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: portrait) {
                .para_align {
                    width: 100%;
                }
            }

            @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: portrait) {
                .left_contentalign {
                    width: 100%;
                }
            }
        `,
    },
    contentWrapper: {
        css: css`
            margin-top: 8px;
        `,
    },
    authorText: {
        css: css`
            > span {
                font-weight: bold;
            }
        `,
    },
    publishDateText: {
        css: css`
            margin-right: 8px;
            > span {
                font-weight: bold;
            }
        `,
    },
    leftSideColumn: {
        width: [12, 12, 12, 9, 9],
        css: css`
            > div {
                max-width: 100%;
            }
        `,
    },
    rightSideColumn: {
        width: [12, 12, 12, 3, 3],
    },
};

const styles = newsPageViewStyles;

const NewsPageView = ({ page, pageTitle, id }: Props) => {
    if (!page) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftSideColumn}>
                <StyledWrapper {...styles.newsWrapper} key={page.id}>
                    <StyledWrapper {...styles.dateAndAuthorWrapper}>
                        {page.fields["publishDate"] && (
                            <Typography {...styles.publishDateText} data-test-selector="newslist_publishdate">
                                <span>{translate("Date of post: ")}</span>
                                <LocalizedDateTime
                                    dateTime={new Date(page.fields["publishDate"])}
                                    options={{ year: "numeric", month: "long", day: "numeric" }}
                                />
                            </Typography>
                        )}
                        {page.fields["author"] && (
                            <Typography {...styles.authorText} data-test-selector="newslist_author">
                                <span>{translate("By: ")}</span>
                                {page.fields["author"]}
                            </Typography>
                        )}
                    </StyledWrapper>
                    {(page.fields["newsSummary"] || page.fields["newsContent"]) && (
                        <StyledWrapper {...styles.contentWrapper} data-test-selector="newslist_content">
                            {parse(page.fields["newsContent"], parserOptions)}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.rightSideColumn}>
                <Zone contentId={id} zoneName="NewsPageView" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(NewsPageView),
    definition: {
        group: "News Page",
        allowedContexts: ["NewsPage"],
    },
};

export default widgetModule;
